var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isReady)?_c('div',{staticClass:"order-confirmation-page"},[_c('cmg-order-confirmation',{attrs:{"order":_vm.order,"delivery-info":_vm.deliveryInfo}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }